// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { HeatmapDataItem} from './types'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'

// Define a service using a base URL and expected endpoints
export const energyHeatmapApi = createApi({
  reducerPath: 'energyHeatmapApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiConfig.heatmapApiUrl,
    prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
  }),
  tagTypes: ['energyHeatmap'],
  endpoints: (builder) => ({
    getHeatmapById: builder.query<HeatmapDataItem[], { id: string, resourceGroupId: string, start: string, end: string, meterType?: string, meterMedium?: string }>({
      query: (arg) => ({
        url: `/${arg.resourceGroupId}/${arg.id}?start=${arg.start}&end=${arg.end}${arg.meterType ? `&meterType=${arg.meterType}` : ''}${arg.meterMedium ? `&meterMedium=${arg.meterMedium}` : ''}`,
        method: 'get'
      }),
    }),
    getHeatmap: builder.query<HeatmapDataItem[], { start: string, end: string, meterType?: string, meterMedium?: string }>({
      query: (arg) => ({
        url: `?start=${arg.start}&end=${arg.end}${arg.meterType ? `&meterType=${arg.meterType}` : ''}${arg.meterMedium ? `&meterMedium=${arg.meterMedium}` : ''}`,
        method: 'get'
      }),
    }),
  }),
})


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetHeatmapQuery,
  useGetHeatmapByIdQuery
} = energyHeatmapApi


